var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden lg:flex items-start px-4 sm:px-6 lg:px-8 xl:hidden border-b text-primary-200 hover:text-white lg:text-primary-800 lg:hover:text-primary-500 print:hidden"},[_c('portal',{staticClass:"lg:hidden",attrs:{"to":"navigation"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }